// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import TickIcon from '../../assets/images/tick-icon.svg';
import UntickIcon from '../../assets/images/tick-icon-unticked.svg';
import CrossIcon from '../../assets/images/tick-cross-icon.svg';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 23px;
  font-size: 14px;
  color: #FFF;
  line-height: 27px;
  border-radius: 17px;
  padding-left: 6px;
  padding-right: 9px;
`;

const S = {
  CompletedContainer: styled(Container)`
    background-color: #4DAB3D;
  `,
  CompletedWithScoreContainer: styled(Container)`
    background-color: #FCA032;
    width: 76px;
  `,
  EndedContainer: styled(Container)`
    background-color: #00C6AD;
  `,
  IncompleteContainer: styled(Container)`
    background-color: #DEDEDE;
  `,
  FailedContainer: styled(Container)`
    background-color: #FE4747;
  `,
  TickIcon: styled.img.attrs({ src: TickIcon, alt: 'tick-icon'})`
    margin-right: 4px;
    width: 15px;
  `,
  UntickIcon: styled.img.attrs({ src: UntickIcon, alt: 'untick-icon'})`
    margin-right: 4px;
    width: 15px;
  `,
  CrossIcon: styled.img.attrs({ src: CrossIcon, alt: 'tick-cross-icon'})`
    margin-right: 4px;
    width: 15px;
  `,
}

export { S as default};
